<template>
  <div class="form-group">
    <div class="row">
      <div class="col-4">
        <FormGroupLabelSection
          :label="formElement.label"
          :icon="formElement.icon"
          :icon-type="formElement.iconType"
          :svg-class="formElement.svgClass"
        />
      </div>
      <div :class="!formElement.dropdown ? 'col-8' : 'col-5'">
        <InputElement
          v-if="formElement.input.type === 'text'"
          v-model="inputModel"
          :name="formElement.input.name"
          :type="formElement.input.type"
          :placeholder="formElement.input.placeholder"
          :is-disable="formElement.input.isDisable"
          :is-locked="formElement.input.isLocked"
          :callback-button="formElement.input.callbackButton"
          :validator="validator"
        />

        <PasswordElement
          v-if="formElement.input.type === 'password'"
          v-model="inputModel"
          :name="formElement.input.name"
          :type="formElement.input.type"
          :placeholder="formElement.input.placeholder"
          :is-disable="formElement.input.isDisable"
          :validator="validator"
        />

        <SelectableDropdownElement
          v-if="formElement.input.type === 'select'"
          v-model:value="inputModel"
          :title="formElement.label"
          type="buttonselect"
          :name="formElement.input.name"
          :placeholder="formElement.input.placeholder"
          :is-disable="formElement.input.isDisable"
          :options="formElement.input.selectOptions"
          @change="$emit('change', $event)"
        />

        <CheckboxElement v-if="formElement.input.type === 'checkbox'"
                         :name="formElement.input.name"
                         :label="formElement.input.placeholder"
                         v-model="inputModel"
                         :is-disable="formElement.input.isDisable"/>

        <SwitchElement v-if="formElement.input.type === 'switch'"
                       :name="formElement.input.name"
                       :label="formElement.input.placeholder"
                       v-model:value="inputModel"/>

        <ToggleElement
          v-if="formElement.input.type === 'toggle'"
          v-model:value="inputModel"
          :title="formElement.label"
          :name="formElement.input.name"
          :placeholder="formElement.input.placeholder"
          :is-disable="formElement.input.isDisable"
          :options="formElement.input.options"
        />
      </div>

      <div class="row row-description" v-if="formElement.description">
        <div class="col-4"></div>
        <div class="col-8">
          <div class="col-12 description">
            <p>{{ formElement.description }}</p>
          </div>
        </div>
      </div>

    </div>
  </div>

</template>
<script lang="ts">
import {defineComponent, type PropType} from 'vue';
import {
  CheckboxElement,
  InputElement,
  PasswordElement,
  SelectableDropdownElement,
  SwitchElement,
  ToggleElement,
} from '@shared/components/elements';

import {CommonNs} from '@shared/types';
import FormGroupLabelSection from '@shared/components/sections/form-group-label.section.vue';

export default defineComponent({
  name: 'FormGroupSection',
  components: {
    PasswordElement,
    InputElement,
    SelectableDropdownElement,
    CheckboxElement,
    SwitchElement,
    FormGroupLabelSection,
    ToggleElement,
  },
  emits: ['update:inputValue', 'update:dropdownValue', 'change'],
  props: {
    formElement: {
      type: Object as PropType<CommonNs.InputFormGroup>,
      required: false,
    },
    inputValue: {
      type: [String, Number, Boolean],
      required: true,
      default: String,
    },
    validator: {
      type: Object,
      default: null,
    },
    draggable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    inputModel: {
      get(): any {
        return this.inputValue;
      },
      set(inputValue: any): void {
        this.$emit('update:inputValue', inputValue);
      },
    },
  },
  methods: {},
  data() {
    return {};
  },
});
</script>

<style lang="scss" scoped>
.form-group {
  width: 100%;
  margin-bottom: 15px;

  & .draggable {
    display: flex;
    align-items: center;
    height: 100%;
  }

  & .notdraggable {
    display: flex;
    align-items: center;
    height: 100%;
  }

  & .action-dropdown {
    display: flex;
    align-items: flex-start;
    justify-content: center;

    & > div {
      display: flex;
      align-items: center;
      width: 100%;
    }
  }

  & .label {
    display: flex;
    align-items: center;
    width: 100%;
    height: 40px;

    & > div {
      display: flex;
      align-items: center;
      width: 100%;
      height: 40px;

      & > .icon {
        display: flex;
        align-items: center;
        width: 50px;
      }

      & > .content {
        width: 100%;
        font-size: var(--fs-14);
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}

.row-description{
  padding: 0 30px;
}

.description {
  margin-top: 15px;
  padding: 0;
  & p {
    font-size: var(--fs-12);
    font-weight: 400;
    color: var(--text-neutral);
    margin: var(--space-0);
    padding-left: 5px;
  }
}

.draggable-icon {
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
}

.notDraggable {
  width: 25px;
  height: 40px;
  margin-right: 5px;

  div {
    width: 25px;
    height: 40px;
    margin-right: 5px;
  }
}

.actions-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: $br-sm;
}

.iconBox {
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center
}

.content {
  justify-content: flex-start !important;
}
</style>
